import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {RouterModule} from "@angular/router";
import {AddToCartButtonModule} from "@app/presentation/components/add-to-cart-button/add-to-cart-button.module";
import {ButtonModule} from "@app/presentation/components/button/button.module";
import {FavButtonModule} from "@app/presentation/components/fav-button/fav-button.module";
import {LocalizedCurrencyModule} from "@app/presentation/pipes/localized-currency/localized-currency.module";
import {TranslateModule} from "@ngx-translate/core";
import {AngularSvgIconModule} from "angular-svg-icon";
import {InfiniteScrollModule} from "ngx-infinite-scroll";
import {ProductLabelsModule} from "../product-labels/product-labels.module";
import {ProductListTileComponent} from './product-list-tile/product-list-tile.component';
import {ProductListComponent} from "./product-list.component";
import {ProductListTileSkeletonComponent} from './product-list-tile-skeleton/product-list-tile-skeleton.component';
import {NgxSkeletonLoaderModule} from "ngx-skeleton-loader";
import {
    ProductPortraitTileSkeletonModule
} from "@app/presentation/components/product-portrait-tile-skeleton/product-portrait-tile-skeleton.module";
import {LocalizeRouterModule} from "@gilsdav/ngx-translate-router";
import {LazyLoadDirectiveModule} from "@app/presentation/directives/lazy-load-image/lazy-load.module";
import {
    AddRemovePdfButtonModule
} from "@app/presentation/components/add-remove-pdf-button/add-remove.pdf-button.module";

@NgModule({
  declarations: [
    ProductListComponent,
    ProductListTileComponent,
    ProductListTileSkeletonComponent
  ],
    imports: [
        CommonModule,
        InfiniteScrollModule,
        AddToCartButtonModule,
        TranslateModule,
        ButtonModule,
        AngularSvgIconModule,
        RouterModule,
        FavButtonModule,
        LocalizedCurrencyModule,
        ProductLabelsModule,
        NgxSkeletonLoaderModule,
        ProductPortraitTileSkeletonModule,
        LocalizeRouterModule,
        LazyLoadDirectiveModule,
        AddRemovePdfButtonModule
    ],
    exports: [
        ProductListComponent,
        ProductListTileComponent,
        ProductListTileSkeletonComponent
    ],
})
export class ProductListModule { }
